import { useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';

interface PrimaryTagsInputProps {
  label?: string;
  placeholder?: string;
  value: string[];
  onChange: (value: string[]) => void;
}

const commitPendingInput = (
  inputValue: string,
  value: string[],
  onChange: (value: string[]) => void,
) => {
  const tag = inputValue.trim();
  if (tag && !value.includes(tag)) {
    onChange([...value, tag]);
  }
};

const PrimaryTagsInput = ({
  label, placeholder, value, onChange,
}: PrimaryTagsInputProps) => {
  const [inputValue, setInputValue] = useState('');

  return (
    <Autocomplete
      multiple
      freeSolo
      size="small"
      options={[]}
      value={value}
      inputValue={inputValue}
      onInputChange={(_event, newInputValue) => setInputValue(newInputValue)}
      onChange={(_event, newValue) => onChange(newValue as string[])}
      onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === ',') {
          event.preventDefault();
          commitPendingInput(inputValue, value, onChange);
          setInputValue('');
        }
      }}
      onBlur={() => {
        commitPendingInput(inputValue, value, onChange);
        setInputValue('');
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
    />
  );
};

PrimaryTagsInput.defaultProps = {
  label: '',
  placeholder: '',
};

export default PrimaryTagsInput;
